import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/mockup/profile.svg'


const _withScopeId = n => (_pushScopeId("data-v-3d23e62e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comment" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "comment-avatar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "user avatar"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "body-author" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Owner Name")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "body-text" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "body-buttons" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Like"),
    /*#__PURE__*/_createElementVNode("p", null, "Comment"),
    /*#__PURE__*/_createElementVNode("p", null, "Share")
  ])
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}